import styled from 'styled-components';

export const SubWrapper = styled.div`
  padding: 2rem 0;
  background: #f7f9fd;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 18px;
  span {
    margin-right: 0.5rem;

    @media (max-width: 960px) {
      display: none;
    }
  }
`;
export const CircleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  line-height: 28px;
  border-radius: 100%;
  border: 1px solid #afb7c1;
  font-size: 12px;
  font-weight: normal;
  text-align: center;
  background: #dee4ff;
  color: #fff;
  border: 1px solid #dee4ff;
  margin-left: 1rem;
`;
export const Circle = styled.div`
  display: inline-block;
  width: 28px;
  height: 28px;
  line-height: 28px;
  border-radius: 100%;
  border: 1px solid #afb7c1;
  font-size: 12px;
  font-weight: normal;
  text-align: center;
  background: #357edd;
  color: #fff;
  border: 1px solid #357edd;
`;
